import { useState, useEffect } from "react";
import { NextPage } from "next";
import styled from "styled-components";
import { getGlobals } from "@models/globals.model";
import { getModulePage, ModulePage } from "@models/module-page.model";
import { Sanity } from "@models/sanity.model";
import { hardwareSlug, shopSlug } from "@utils/routes";
import Layout from "@components/layout";
import ComponentResolver from "@components/component-resolver";
import BackButton from "@components/ui/back-button";
import { getSectioningContext } from "@components/component-resolver/sectionContext";
import { rem } from "@styles/helpers";
import { Device } from "@styles/constants";

const BackWrap = styled.div`
  margin-top: ${rem(30)};

  @media ${Device.medium} {
    margin-top: ${rem(60)};
  }
`;

export interface PackagesPageProps extends Sanity.PageProps {
  page: ModulePage;
}

const Packages: NextPage<PackagesPageProps> = ({ globals, page }) => {
  const { hide_header_banner, marketing_modules, seo } = page;

  const [referrer, setReferrer] = useState("");

  useEffect(() => {
    setReferrer(document.referrer);
  }, []);

  return (
    <Layout
      globals={globals}
      pageID={page?.slug?.current}
      hideBanner={hide_header_banner}
      seo={seo}>
      {referrer?.includes(shopSlug) && (
        <BackWrap className="grid-container">
          <BackButton href={hardwareSlug} />
        </BackWrap>
      )}

      {marketing_modules?.length > 0 &&
        marketing_modules.map((schema: Sanity.Document, i: number) => {
          const sectioningContext = getSectioningContext({ modules: marketing_modules, index: i });
          return (
            <ComponentResolver
              key={`${schema._type}_${i}`}
              schema={schema}
              sectioningContext={sectioningContext}
            />
          );
        })}
    </Layout>
  );
};

export default Packages;

export async function getStaticProps() {
  const [globals, page] = await Promise.all([await getGlobals(), await getModulePage("packages")]);

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      globals,
      page,
    },
  };
}
